/* ============================================================
   RAFFE STAFFING — raffe.js  v3.0
   ============================================================ */
(function () {
  'use strict';

  /* ── SCROLL FADE-IN ── */
  var els = document.querySelectorAll('.spec-card, .stat-card, .step, .client-tile, .pillar, .portal-benefit, .db-card, .wie-pillar');
  els.forEach(function (el) { el.classList.add('js-fade'); });
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); } });
    }, { threshold: 0.1 });
    els.forEach(function (el) { obs.observe(el); });
  } else {
    els.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ── SMOOTH SCROLL ── */
  document.querySelectorAll('a[href^="/#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var hash = this.getAttribute('href').replace('/', '');
      if (window.location.pathname === '/') {
        var t = document.querySelector(hash);
        if (t) { e.preventDefault(); var offset = (document.querySelector('.nav') || {}).offsetHeight || 80; window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - offset - 20, behavior: 'smooth' }); }
      }
    });
  });

  /* ── NAV SHADOW ── */
  var nav = document.querySelector('.nav');
  if (nav) window.addEventListener('scroll', function () { nav.style.boxShadow = window.scrollY > 20 ? '0 2px 20px rgba(0,0,0,0.08)' : 'none'; }, { passive: true });

  /* ── STEP NAVIGATION ── */
  window.raffeNextStep = function (cur) {
    var page = document.getElementById('form-page-' + cur);
    if (!page) return;
    var ok = true;
    page.querySelectorAll('[required]').forEach(function (el) { if (!el.checkValidity()) { el.reportValidity(); ok = false; } });
    if (!ok) return;
    var next = cur + 1;
    document.getElementById('form-page-' + cur).classList.remove('active');
    document.getElementById('form-page-' + next).classList.add('active');
    document.getElementById('step-ind-' + cur).classList.remove('active');
    document.getElementById('step-ind-' + cur).classList.add('done');
    document.getElementById('step-ind-' + next).classList.add('active');
    var card = document.querySelector('.portal-form-card');
    if (card) card.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  window.raffePrevStep = function (cur) {
    var prev = cur - 1;
    document.getElementById('form-page-' + cur).classList.remove('active');
    document.getElementById('form-page-' + prev).classList.add('active');
    document.getElementById('step-ind-' + cur).classList.remove('active');
    document.getElementById('step-ind-' + prev).classList.remove('done');
    document.getElementById('step-ind-' + prev).classList.add('active');
  };

  /* ── FILE DROP ZONE ── */
  var fileInput = document.getElementById('c-resume');
  var dropZone  = document.getElementById('file-drop-zone');
  var fdzC = document.getElementById('fdz-content');
  var fdzS = document.getElementById('fdz-selected');
  var fdzF = document.getElementById('fdz-filename');

  function showFile(f) { if (!fdzC || !fdzS || !fdzF) return; fdzC.style.display = 'none'; fdzS.style.display = 'flex'; fdzF.textContent = f.name + ' (' + (f.size / 1024 / 1024).toFixed(1) + ' MB)'; }
  if (fileInput) fileInput.addEventListener('change', function () { if (this.files && this.files[0]) showFile(this.files[0]); });
  if (dropZone) {
    dropZone.addEventListener('dragover', function (e) { e.preventDefault(); this.classList.add('drag-over'); });
    dropZone.addEventListener('dragleave', function () { this.classList.remove('drag-over'); });
    dropZone.addEventListener('drop', function (e) { e.preventDefault(); this.classList.remove('drag-over'); var f = e.dataTransfer.files[0]; if (f) { fileInput.files = e.dataTransfer.files; showFile(f); } });
  }
  window.raffeClearFile = function () { if (fileInput) fileInput.value = ''; if (fdzS) fdzS.style.display = 'none'; if (fdzC) fdzC.style.display = 'block'; };

  /* ── FORM SUBMISSION ── */
  var form    = document.getElementById('raffe-candidate-form');
  var btn     = document.getElementById('candidate-submit-btn');
  var success = document.getElementById('candidate-success');
  var fields  = document.getElementById('candidate-fields');
  var errEl   = document.getElementById('candidate-error');
  var header  = document.getElementById('pfc-header');
  var emailEl = document.getElementById('c-email');

  if (emailEl && form) emailEl.addEventListener('input', function () { var h = form.querySelector('[name="_replyto"]'); if (h) h.value = this.value; });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!form.checkValidity()) { form.reportValidity(); return; }
      btn.textContent = 'Submitting\u2026'; btn.disabled = true;
      if (errEl) errEl.style.display = 'none';
      fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function (res) {
          if (res.ok) { if (fields) fields.style.display = 'none'; if (success) success.style.display = 'block'; if (header) header.style.display = 'none'; }
          else { throw new Error(); }
        })
        .catch(function () { if (errEl) errEl.style.display = 'block'; btn.textContent = 'Submit \u2014 Join the Network \u2192'; btn.disabled = false; });
    });
  }

})();
